import { Component, EventEmitter, Injector, OnDestroy, OnInit, Output, } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material/dialog";
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { APIService } from '../common/api.component';
import { Constants } from '../common/constants';
import { GlobalVariableConstants } from '../common/globalVariable';
import { SharedService } from '../common/shared.service';
import { ShareUtils } from '../common/shareutils';
import { Utils } from '../common/utils.component';
import { ShareSettings } from '../models/sharesettin';
import { UploadDuplicateData } from './uploadDuplicateData';

/*
   Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}')
*/
@Component({
  selector: 'duplicate-dialog',
  templateUrl: './duplicate-dialog.component.html'
})
export class DuplicateDialogComponent implements OnInit, OnDestroy {

  @Output() handleDuplicateFileSaveEvent = new EventEmitter

  fileOptions = GlobalVariableConstants.duplicateFileSaveOptions;

  filename: string = "";
  sitename: string = ""
  loading = true;

  parentFolderId: number
  siteId: number
  uploadPath: string
  duplicateFileDetectionLevel: number

  dialogRef: MatDialogRef<DuplicateDialogComponent>;
  data: any;
  subscription: Subscription;
  uploadDuplicateData: UploadDuplicateData;
  errorMsg = { str: "" }

  constructor(private sharedSer: SharedService, private injector: Injector,
    private apiService: APIService,
    private route: Router,
    public dialog: MatDialog) {
    this.dialogRef = this.injector.get(MatDialogRef, null);
    this.data = this.injector.get(MAT_DIALOG_DATA, null);

    this.subscription = this.sharedSer.updateDuplicateData$.subscribe(
      uploadDuplicateData => {
        this.uploadDuplicateData = uploadDuplicateData
        this.parseDialogData()
      });

  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe()
    this.sharedSer.updateDuplicateData$.next(null)

  }
  parseDialogData() {
    if (this.uploadDuplicateData != null && this.uploadDuplicateData != undefined && this.uploadDuplicateData.fileid != undefined) {
      this.filename = this.uploadDuplicateData.filename;
      this.sitename = this.uploadDuplicateData.sitename;

      this.parentFolderId = this.uploadDuplicateData.parentFolderId
      this.siteId = this.uploadDuplicateData.siteId
      this.uploadPath = this.uploadDuplicateData.uploadPath
      this.duplicateFileDetectionLevel = this.uploadDuplicateData.duplicateFileDetectionLevel

    } else {
      if (this.data != null) {
        this.filename = this.data.filename;
        this.sitename = this.data.sitename;
      }
    }
    this.loading = false;
  }

  ngOnInit() {
    this.apiService.ValidateMsTeamContextAndFatchTeamsId(this.sharedSer);
    this.apiService.setTheme();
  }


  public saveNewFile() {
    this.route.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.route.navigateByUrl('/upload', { state: { parentFolderId: this.parentFolderId, isShareLink: false, siteId: this.siteId, uploadPath: this.uploadPath, overrideDuplicate: false, duplicateFileDetectionLevel: this.duplicateFileDetectionLevel, duplicationchecked: true } }));
  }

  redirectTo(uri: string) {
    this.route.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.route.navigate([uri]));
  }

  public addVersion() {
    this.route.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.route.navigateByUrl('/upload', { state: { parentFolderId: this.parentFolderId, isShareLink: false, siteId: this.siteId, uploadPath: this.uploadPath, overrideDuplicate: true, duplicateFileDetectionLevel: this.duplicateFileDetectionLevel, duplicationchecked: true } }));

  }


  public skip() {
    this.route.navigateByUrl('/?mode=2');
  }

  clearErrorMsg() {
    this.errorMsg.str = ""
  }


  closeDialog() {
    this.dialogRef.close
  }


  //Choose file option if file is duplicate
  duplicateFileSave(value: any) {

    switch (value) {
      case GlobalVariableConstants.saveNewFileKey:
        this.saveNewFile();
        break;

      case GlobalVariableConstants.addVersionKey:
        this.addVersion();
        break;
    }
    
  }

  //On duplicate file save option change
  enableUploadButton(value: any): void {
    //call parent(upload component)
    this.handleDuplicateFileSaveEvent.emit(value)
  }

}
